import { useEffect } from 'react';
import { createRootRoute, createRoute, createRouter, Link } from '@tanstack/react-router';
import type { AppEntry } from '@/app/routes-types';
import { BusTimesPage } from '@/features/bus-times/BusTimesPage';
import { SURFACES } from '@/lib/gql/__generated__/surfaces';
import { guardSurface } from '@/lib/platform/surfaces';
export const entry: AppEntry = { default: '/', byRole: {} };
function NotFoundPage() {
  useEffect(() => {
    const root = document.getElementById('root');
    root?.setAttribute('data-app-notfound', '1');
    return () => root?.removeAttribute('data-app-notfound');
  }, []);
  return (
    <main className="grid min-h-screen place-items-center p-6">
      <section className="max-w-md rounded-xl border bg-card p-8 text-center">
        <p className="text-sm font-medium text-primary">404</p>
        <h1 className="mt-2 text-2xl font-semibold">That stop is not on this board.</h1>
        <Link className="mt-5 inline-block text-primary underline" to="/">
          Return to bus times
        </Link>
      </section>
    </main>
  );
}
const rootRoute = createRootRoute({ notFoundComponent: NotFoundPage });
const busTimesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => guardSurface(entry, SURFACES['bus-times']),
  component: BusTimesPage,
  staticData: { title: 'Seattle Bus Times', page: SURFACES['bus-times'], standalone: false, isPublic: true },
});
const routeTree = rootRoute.addChildren([busTimesRoute]);
export const router = createRouter({ routeTree, notFoundMode: 'root' });
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
